export * from './queue.service'

export enum QueueActions {
  Enqueue = "Enqueue",
  Dequeue = "Dequeue",
  Pending = "Pending",
}

export interface QueueItem {
  id?: number;
  type: QueueType;
  data: any;
  created_on?: Date;
  completed_on?: Date;
  created_by?: string;
}

export enum QueueType {
  ExportBatches,
  ExportDocuments,
  AbiRequest,
  AbiDocumentRequest,
  ExportDocumentPrints,
  WorkspaceExport,
  WorkspaceSelectionExport,
  None,
}

export enum AbiType {
  None,
  PrintEntrySummary,
  PrintCargoReRelease,
  PrintDeliveryOrder,
  PrintInbound7512,
  PrintIsfDocument,
  ManifestBillOfLandingQuery,
  ManifestAirwayBillQuery,
  Manifest
}
export interface TablePageOptions {
  count?: number;
  orderBy: any;
  groupBy?: string;
  columns?:any
  filter: any | string | null | any[];
  filterables: string | null;
  size: number;
  current: number;
}
